import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Link } from "react-router-dom";

const fmtD = (iso) => (iso ? iso.split("-").reverse().join(".") : "");

export default function FuelAnomalyBanner() {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(true);

  useEffect(() => {
    api.get("/cars/fuel-anomalies").then((r) => setRows(r.data || [])).catch(() => setRows([]));
  }, []);

  if (!rows.length) return null;
  return (
    <div className="rounded-lg border-2 border-cyan-500 bg-cyan-50 overflow-hidden" data-testid="fuel-anomaly-banner">
      <button onClick={() => setOpen((v) => !v)} className="w-full px-4 py-2.5 flex items-center gap-2 text-left">
        <span className="font-bold text-sm text-cyan-900">⛽ Consum anormal: {rows.length} mașini (ultima alimentare vs. media proprie)</span>
        <span className="ml-auto text-cyan-700 text-xs font-bold">{open ? "▲" : "▼"}</span>
      </button>
      {open && (
        <div className="px-4 pb-3 space-y-1.5">
          {rows.map((r) => (
            <div key={r.car_id} className="bg-white border border-cyan-200 rounded px-3 py-1.5 text-sm flex flex-wrap items-center gap-x-3 gap-y-0.5" data-testid={`fuel-anomaly-${r.car_id}`}>
              <Link to="/autoturisme" className="font-bold hover:underline">🚐 {r.car_label}</Link>
              <span className={`text-xs font-black px-1.5 py-0.5 rounded ${r.direction === "high" ? "bg-red-100 text-red-700" : "bg-blue-100 text-blue-700"}`}>
                {r.direction === "high" ? "🔺" : "🔻"} {r.deviation_pct > 0 ? "+" : ""}{r.deviation_pct}%
              </span>
              <span className="text-xs tabular-nums"><b>{r.last_l100}</b> L/100km vs. media <b>{r.median_l100}</b></span>
              <span className="text-[11px] text-zinc-500">{fmtD(r.date)} · {r.liters}L pe {r.km_interval} km{r.persoana ? ` · alimentat de ${r.persoana}` : ""}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
